module.exports = __webpack_public_path__ + "static/media/frong-rabit.45b5bac0.jpg";